import { render } from "./DomainCnameBtn.vue?vue&type=template&id=3a72c60f"
import script from "./DomainCnameBtn.vue?vue&type=script&lang=js"
export * from "./DomainCnameBtn.vue?vue&type=script&lang=js"

import "./DomainCnameBtn.vue?vue&type=style&index=0&id=3a72c60f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__